import { KeyValue } from "@/main/models/common";
import { InsurerFilterRequest } from "@/main/models/request/insurerRequest";
import { InsuranceSublineTypes, InsuranceSublineActionTypes } from "./insuranceSublineTypes";

export function getInsuranceSublines(
	request: InsurerFilterRequest,
	keyReducer: string = "default",
): InsuranceSublineActionTypes {
	return {
		type: InsuranceSublineTypes.GET_INSURANCE_SUBLINES,
		payload: {
			request,
			keyReducer,
		},
	};
}

export function saveInsuranceSublines(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
	keyReducer: string = "default",
): InsuranceSublineActionTypes {
	return {
		type: InsuranceSublineTypes.SAVE_INSURANCE_SUBLINES,
		payload: { data, isError, errorMessages, keyReducer },
	};
}

export function resetReducerInsuranceSublines(): InsuranceSublineActionTypes {
	return {
		type: InsuranceSublineTypes.RESET_REDUCER_INSURANCE_SUBLINES,
	};
}
